import { CircularProgress, IconButton, ListItem, ListItemSecondaryAction, ListItemText, Typography, makeStyles } from '@material-ui/core';
import { AddCircleOutline, CheckCircle } from '@material-ui/icons';
import React, { useEffect, useMemo, useState } from 'react';
import { localizeCurrency } from 'util/localizeFormat';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
}));
const ServiceLineItem = ({
  item,
  index,
  onSelect = async (item) => { },
  selectedItems,
  displayCoverage = false,
  comparator,
  forwardMapping
}) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()

  const isSelected = useMemo(
    () => {
      return selectedItems?.find(x => {
        if (comparator) {
          return comparator(x, forwardMapping ? forwardMapping(item) : item)
        }
        return x?.id === item?.id
      })
    }, [selectedItems, item]
  );
  const [loading, setLoading] = useState(false);

  return (
    <ListItem
      button
      selected={isSelected}
      onClick={async () => {
        setLoading(true)
        await onSelect(isSelected)
        setLoading(false)
      }}>
      <ListItemText
        primary={<Typography variant="body2">
          {item?.label}
        </Typography>
        }
        secondary={
          <Typography variant="caption">
            {localizeCurrency(item?.fee)}
          </Typography>
        }
      />
      {displayCoverage && <Typography variant='caption' color='textSecondary'>{item?.is_white_label_covered ? '' : 'not covered'}</Typography>}
      {loading ? <CircularProgress size={20} /> :
        isSelected ?
          <CheckCircle color='primary' /> : <AddCircleOutline color='primary' />
      }


    </ListItem>
  )
}

export { ServiceLineItem }